import classNames from "classnames";
import type { Control } from "react-hook-form";

import ComposerParamInput from "./ComposerParamInput/index.js";
import { buildName } from "./ComposerParamInput/lib.js";
import type { ComposerFormState } from "./lib/form.js";
import type { ComposerMethodConfig } from "./lib/methods.js";

interface ComposerParamsProps extends React.HTMLAttributes<HTMLDivElement> {
  control: Control<ComposerFormState>;
  methodConfig: ComposerMethodConfig;
}

const ComposerParams = ({
  control,
  methodConfig,
  className,
  ...props
}: ComposerParamsProps) => {
  const isJsonRPCMethod =
    methodConfig.requestBody?.type === "object" &&
    methodConfig.requestBody?.properties["jsonrpc"]?.default === "2.0";
  const jsonRPCparams =
    isJsonRPCMethod && methodConfig.requestBody?.type === "object"
      ? methodConfig.requestBody.properties["params"]
      : null;
  const requestBody = isJsonRPCMethod
    ? jsonRPCparams
    : methodConfig.requestBody;

  return (
    <div
      {...props}
      className={classNames(
        className,
        "flex flex-col gap-4 rounded-lg border border-primary bg-subtle p-3",
      )}
    >
      {!requestBody && !methodConfig.queryParams?.length ? (
        <span className="text-paragraph-200-regular text-secondary">
          This method has no parameters you can configure
        </span>
      ) : null}

      {methodConfig.queryParams?.map((param, index) => {
        return (
          <ComposerParamInput
            key={index}
            control={control as unknown as Control}
            name={buildName("query", param.name)}
            param={param}
          />
        );
      })}

      {requestBody ? (
        <ComposerParamInput
          control={control as unknown as Control}
          name={isJsonRPCMethod ? "body.params" : "body"}
          param={requestBody}
        />
      ) : null}
    </div>
  );
};

export default ComposerParams;
